// Console output only in development; silent in production builds
export const devLog = (level, ...args) => {
  if (process.env.NODE_ENV !== "production") console[level](...args);
};
